<template>
  <div class="container bot-order-page">
    <div class="mb-3 text-center bot-order-title">
      <label>{{ orderTitle }}</label>
    </div>
    <form
      class="container flow-show bot-order-form"
      v-on:submit.prevent="confirm"
    >
      <div class="text-left mb-3">
        <div class="mb-3">Продукти</div>
        <form
          v-on:submit.prevent="addProduct"
          class="product-add-form mb-3"
          v-if="isEditable"
        >
          <v-select
            class="product-add-control bot-select-no-clear"
            :options="lookupPagination.entities"
            :modelValue="selectedLookupProduct"
            :clearable="true"
            :filterable="false"
            :get-option-label="getLookupDisplayLabel"
            :loading="lookupLoading"
            placeholder="Пошук продукту"
            @search="onProductSearch"
            @open="onProductLookupOpen"
            @close="onProductLookupClose"
            @update:modelValue="selectLookupProduct"
            @clear="resetSelectedProduct(true)"
          >
            <template #option="option">
              <div>{{ getLookupDisplayLabel(option) }}</div>
            </template>
            <template #selected-option="option">
              <div>{{ getLookupDisplayLabel(option) }}</div>
            </template>
            <template #list-footer>
              <li
                v-if="lookupLoading || hasMoreLookupPages"
                class="px-3 py-2 border-top text-center text-muted"
              >
                <span v-if="lookupLoading">Завантаження...</span>
              </li>
            </template>
            <template #no-options>
              <span v-if="lookupLoading">Завантаження...</span>
              <span v-else>{{ $filters.localize("select.noOptions") }}</span>
            </template>
          </v-select>
          <v-select
            class="product-add-control bot-select-no-clear"
            :options="lookupCharacters"
            v-model="product.productRemainId"
            :reduce="(option) => option.id"
            :disabled="lookupCharacters.length === 0"
            :clearable="true"
            :get-option-label="getLookupCharacterLabel"
            placeholder="Розмір"
          >
            <template #option="option">
              <div>{{ option.character.name }}</div>
            </template>
            <template #selected-option="option">
              <div>{{ option.character.name }}</div>
            </template>
            <template #no-options>
              {{ $filters.localize("select.noOptions") }}
            </template>
          </v-select>
          <button
            class="btn btn-outline-secondary product-add-button"
            :disabled="!isEditable || !selectedLookupProduct || !product.productRemainId"
            type="submit"
          >
            {{ $filters.localize("button.add") }}
          </button>
        </form>

        <table class="table table-sm">
          <thead>
            <tr>
              <th
                class="text-center"
                v-for="header of productHeaders"
                v-bind:key="header.name"
              >
                <p class="d-inline">{{ header.name }} &nbsp;</p>
              </th>
              <th class="text-center" v-if="isTailoring">
                <p class="d-inline">{{ $filters.localize("ProductPage.fields.tailoringTerm") }} &nbsp;</p>
              </th>
              <th v-if="isEditable"></th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(row, index) of products"
              v-bind:key="index"
            >
              <td class="text-center">
                <label class="form-control text-center">{{
                  row.product.code
                }}</label>
              </td>
              <td>
                <label class="form-control text-center">{{
                  row.productRemain.character?.code
                }}</label>
              </td>
              <td>
                <label class="form-control text-center">{{
                  formatLookupPrice(row.price)
                }}</label>
              </td>
              <td v-if="isTailoring">
                <label class="form-control text-center">{{
                  getTailoringTermLabel(row)
                }}</label>
              </td>
              <td
                class="text-center"
                v-if="isEditable"
              >
                <button
                  type="button"
                  class="btn btn-sm btn-danger"
                  :disabled="!isEditable"
                  v-on:click="rmProduct(index)"
                >
                  X
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        <div
          class="container text-center"
          v-if="products.length === 0"
        >
          Продукти відсутні в замовленні
        </div>
      </div>
      <div
        v-if="showPromotions"
        class="text-left"
      >
        <div class="mb-3">Подарунки</div>
        <form
          v-on:submit.prevent="addPromotion"
          class="promotion-add-form mb-3"
          v-if="isEditable"
        >
          <select
            class="form-control promotion-add-control"
            v-model="promotionId"
            required
          >
            <option
              value=""
              disabled
              selected
            >Подарунок</option>
            <option
              v-for="option in promotionsFilter"
              v-bind:key="option.id"
              :value="option.id"
            >
              {{ option.name }}
            </option>
          </select>
          <div class="input-group-append promotion-add-actions">
            <button
              :disabled="!isEditable"
              class="btn btn-outline-secondary promotion-add-button"
              type="submit"
            >
              {{ $filters.localize("button.add") }}
            </button>
          </div>
        </form>

        <table class="table table-sm">
          <thead>
            <tr>
              <th
                class="text-center"
                v-for="header of promotionHeaders"
                v-bind:key="header.name"
              >
                <p class="d-inline">{{ header.name }} &nbsp;</p>
              </th>
              <th v-if="isEditable"></th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(row, index) of promotionsInEntity"
              v-bind:key="index"
            >
              <td class="text-center">
                <select
                  :disabled="true"
                  class="form-control text-center"
                  v-model="row.promotionId"
                >
                  <option
                    v-for="option in promotions"
                    v-bind:key="option.id"
                    :value="option.id"
                  >
                    {{ option.name }}
                  </option>
                </select>
              </td>
              <td class="text-center">
                <button
                  type="button"
                  v-if="isEditable"
                  class="btn btn-sm btn-danger"
                  v-on:click="rmPromotion(index)"
                >
                  X
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        <div
          class="container text-center mb-3"
          v-if="promotionsInEntity.length === 0"
        >
          Подарунки відсутні в замовленні
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-sm mb-3 text-left">
          <label class="form-label">Служба доставки</label>
          <select
            :disabled="deliveryServices.length === 0 || !isEditable"
            class="form-control"
            v-model="entity.deliveryServiceId"
            required
          >
            <option
              value=""
              disabled
              selected
            ></option>
            <option
              v-for="option in deliveryServices"
              v-bind:key="option.id"
              :value="option.id"
            >
              {{ option.name }}
            </option>
          </select>
        </div>
        <div class="col-sm mb-3 text-left">
          <label class="form-label">Тип оплати</label>
          <select
            :disabled="deliveryTypesFilter.length === 0 ||
              deliveryServiceId === null ||
              !isEditable
              "
            class="form-control"
            v-model="deliveryTypeId"
            required
          >
            <option
              value=""
              disabled
              selected
            ></option>
            <option
              v-for="option in deliveryTypesFilter"
              v-bind:key="option.id"
              :value="option.id"
            >
              {{ option.name }}
            </option>
          </select>
        </div>
      </div>
      <div class="row">
        <div class="col-sm mb-3 text-left">
          <label class="form-label">Місто</label>
          <input
            type="text"
            class="form-control"
            v-if="
              entity.deliveryServiceId != '1bf61851-347c-4d0d-a62e-d488dce9c0da'
            "
            :disabled="!isEditable"
            v-model="entity.city"
            required
          />
          <selector-city
            v-else
            class="bot-select-no-clear"
            :disabled="!isEditable"
            :entity="entity"
            @update="
              (value) => {
                entity.city = value?.code || '';
                entity.cityName = value?.label || '';
                entity.address = '';
              }
            "
            :required="true"
          />
        </div>
        <div class="col-sm mb-3 text-left">
          <label class="form-label">Відділення пошти / індекс / адреса
            доставки</label>
          <input
            type="text"
            class="form-control"
            :disabled="!isEditable"
            v-if="
              entity.deliveryServiceId != '1bf61851-347c-4d0d-a62e-d488dce9c0da'
            "
            v-model="entity.address"
            required
          />
          <selector-address
            v-else
            class="bot-select-no-clear"
            :disabled="!isEditable"
            :entity="entity"
            @update="
              (value) => {
                entity.address = value || '';
              }
            "
            :disable="!entity.city || entity.city.length === 0"
            :required="true"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-sm mb-3 text-left">
          <label class="form-label">Отримувач</label>
          <input
            type="text"
            class="form-control"
            :disabled="!isEditable"
            v-model="entity.recipient"
            required
          />
        </div>
        <div class="col-sm mb-3 text-left">
          <label class="form-label">Мобільний телефон</label>
          <input
            pattern="^\+[0-9]{12}"
            type="tel"
            placeholder="+380111111111"
            class="form-control"
            :disabled="!isEditable"
            v-model="entity.recipientPhone"
            required
          />
        </div>
      </div>
      <div class="row">
        <div class="col-sm mb-3 text-left">
          <label class="form-label">Сума оплати</label>
          <input
            type="number"
            :min="minPaymentAmount"
            :max="maxPaymentAmount"
            class="form-control"
            :disabled="!isEditable"
            v-model="entity.paymentAmount"
            :required="minCashPaidAmount > 0 && entity.bonusPaidAmount != 0"
          />
          <small class="form-text text-muted">
            Мінімальна передплата: {{ minPaymentAmount }}
          </small>
        </div>
        <div
          v-if="entity.paymentAmount > 0"
          class="col-sm mb-3 text-left"
        >
          <label class="form-label">Дата оплати</label>
          <input
            type="date"
            class="form-control"
            :disabled="!isEditable"
            v-model="paymentDate"
            required
          />
        </div>
        <div
          v-if="entity.paymentAmount > 0"
          class="col-sm mb-3 text-left"
        >
          <label class="form-label">Час оплати</label>
          <input
            type="time"
            class="form-control"
            :disabled="!isEditable"
            v-model="paymentTime"
            required
          />
        </div>
      </div>
      <div
        v-if="entity.paymentAmount > 0"
        class="row mb-3"
      >
        <div class="col-sm mb-3 text-left">
          <label class="form-label">Куди сплатили</label>
          <select
            :disabled="fops.length === 0"
            class="form-control"
            v-model="entity.paymentDetailId"
            required
          >
            <option
              v-for="option in fops"
              v-bind:key="option.id"
              :value="option.id"
            >
              {{ option.name }}
            </option>
          </select>
        </div>
        <div class="col-sm mb-3 text-left">
          <label class="form-label">П.І.Б платника</label>
          <input
            type="text"
            class="form-control"
            :disabled="!isEditable"
            v-model="entity.paymentPayer"
            required
          />
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-sm mb-3 text-left">
          <label class="form-label">Сума накладеного платежу</label>
          <input
            type="number"
            :disabled="isFullPayment || !isEditable"
            :min="minCashPaidAmount"
            class="form-control"
            v-model="entity.cashPaidAmount"
            :required="minCashPaidAmount > 0 && entity.bonusPaidAmount != 0"
          />
        </div>
        <div
          v-if="this.balance > 0"
          class="col-sm mb-3 text-left"
        >
          <label class="form-label">Оплата балансом</label>
          <input
            type="number"
            min="0"
            :max="balance"
            class="form-control"
            :disabled="!isEditable"
            v-model="entity.bonusPaidAmount"
            required
          />
          <small class="form-text text-danger">
            Баланс: {{ balance }}
          </small>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-sm mb-3 text-left">
          <label class="form-label">Коментар</label>
          <textarea
            :disabled="!isEditable"
            class="form-control"
            v-model="entity.comment"
          />
        </div>
      </div>
      <div
        class="text-center mb-3"
        v-if="isEditable"
      >
        <button
          :disabled="products.length === 0 || !isEditable || isBlockSubmit"
          type="submit"
          class="btn btn-block btn btn-outline-success"
        >
          {{ $filters.localize("button.submit") }}
        </button>
      </div>
      <div
        class="text-center"
        style="margin-top: 100px"
      >
        <p>&nbsp;</p>
      </div>
    </form>
  </div>
</template>

<script>
(function () {
  function pad(number) {
    if (number < 10) {
      return "0" + number;
    }
    return number;
  }

  Date.prototype.toISOString = function () {
    return (
      this.getFullYear() +
      "-" +
      pad(this.getMonth() + 1) +
      "-" +
      pad(this.getDate()) +
      "T" +
      pad(this.getHours()) +
      ":" +
      pad(this.getMinutes()) +
      ":" +
      pad(this.getSeconds()) +
      "." +
      (this.getMilliseconds() / 1000).toFixed(3).slice(2, 5)
    );
  };
})();

import { PromotionTypes } from "@/utilities/PromotionTypes.js";
import SelectorCity from "@/components/Selectors/SelectorCity.vue";
import SelectorAddress from "@/components/Selectors/SelectorAddress.vue";
import { nextTick } from "vue";
import vSelect from "vue-select";
import { localizeDeliveryServices } from "@/utilities/DeliveryService";
export default {
  name: "OrderBot",
  components: { SelectorCity, SelectorAddress, vSelect },
  props: {
    showPromotions: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    deliveryTypeId: {
      get() {
        return this.entity.deliveryTypeId;
      },
      set(value) {
        this.entity.deliveryTypeId = value;
        if (this.isFullPayment) this.entity.cashPaidAmount = 0;
        this.syncPromotionProductBonus();
      },
    },
    isEditable: {
      get() {
        return (
          this.entity.statusId === "2bf61851-347c-4d0d-a62e-d488dce9c0da" ||
          this.entity.statusId === "1bf61851-347c-4d0d-a62e-d488dce9c0da" ||
          this.action == null
        );
      },
    },
    promotionId: {
      get() {
        return this.promotion.promotionId;
      },
      set(value) {
        this.promotion.promotionId = value;
        this.promotion.typeId = this.promotions.find(
          (x) => x.id === value
        ).typeId;
        this.promotion.value = this.promotions.find(
          (x) => x.id === value
        ).value;
      },
    },
    lookupCharacters: {
      get() {
        return [...(this.selectedLookupProduct?.remains ?? [])].sort((a, b) =>
          (a.character?.name ?? "").localeCompare(b.character?.name ?? "")
        );
      },
    },
    hasMoreLookupPages: {
      get() {
        return this.lookupPagination.page < this.lookupPagination.totalPages;
      },
    },
    promotionsFilter: {
      get() {
        const { IS_FOR_ALL, PROMO_PRODUCT, IS_FOR_RETAIL } = PromotionTypes;
        let productPromotionCount = this.products.filter(
          (x) => x.product?.isPromotion
        ).length;
        if (this.isFullPayment && productPromotionCount > 0) {
          let proms = this.promotions.filter((x) => x.typeId !== IS_FOR_RETAIL);
          if (
            this.promotionsInEntity.map((x) => x.typeId).includes(PROMO_PRODUCT)
          ) {
            let pie = this.promotionsInEntity.filter(
              (x) => x.typeId === PROMO_PRODUCT
            );
            if (pie.length < productPromotionCount)
              proms = proms.filter(
                (x) =>
                  x.typeId === IS_FOR_ALL ||
                  pie.map((x) => x.promotionId).includes(x.id)
              );
            else proms = proms.filter((x) => x.typeId === IS_FOR_ALL);
          }
          return proms;
        } else {
          return this.promotions.filter(
            (x) => x.typeId !== PROMO_PRODUCT && x.typeId !== IS_FOR_RETAIL
          );
        }
      },
    },

    request: {
      get() {
        var obj = JSON.parse(JSON.stringify(this.entity));
        obj.kind = "Wholesale";
        obj.paymentAmount = Number(obj.paymentAmount || 0);
        obj.bonusPaidAmount = Number(obj.bonusPaidAmount || 0);
        obj.cashPaidAmount = Number(obj.cashPaidAmount || 0);
        if (obj.paymentAmount <= 0) {
          obj.paymentAmount = 0;
          obj.paymentDetailId = null;
          obj.paymentPayer = null;
          obj.paymentTime = null;
        }
        obj.products = JSON.parse(JSON.stringify(this.products));
        obj.promotions = JSON.parse(JSON.stringify(this.promotionsInEntity));
        return obj;
      },
    },
    isFullPayment: {
      get() {
        return (
          this.entity.deliveryTypeId === "1bf61851-347c-4d0d-a62e-d488dce9c0da"
        );
      },
    },
    deliveryTypesFilter: {
      get() {
        if (
          this.entity?.deliveryServiceId ===
          "1bf61851-347c-4d0d-a62e-d488dce9c0da" &&
          this.promotionsInEntity.filter(
            (x) => x.typeId === "2bf61851-347c-4d0d-a62e-d488dce9c0da"
          ).length === 0
        ) {
          return this.deliveryTypes;
        } else {
          return [
            ...this.deliveryTypes.filter(
              (x) => x.id !== "2bf61851-347c-4d0d-a62e-d488dce9c0da"
            ),
          ];
        }
      },
    },
    minPaymentAmount: {
      get() {
        var sum = this.promotionsInEntity
          .filter((x) => x.value < 0)
          .map((x) => x.value)
          .reduce((a, b) => a + b, 0);
        const totalDue =
          this.products.map((x) => x.price).reduce((a, b) => a + b, 0) +
          Math.abs(sum) -
          this.entity.bonusPaidAmount;
        const minimum = this.isFullPayment
          ? totalDue
          : this.prePaymentBaseValue +
          Math.max(0, this.products.length - 1) *
          this.prePaymentStepValue +
          Math.abs(sum) -
          this.entity.bonusPaidAmount;

        return Math.max(0, Math.min(totalDue, minimum));
      },
    },
    maxPaymentAmount: {
      get() {
        var sum = this.promotionsInEntity
          .filter((x) => x.value < 0)
          .map((x) => x.value)
          .reduce((a, b) => a + b, 0);
        var sumCash = this.products
          .map((x) => x.price)
          .reduce((a, b) => a + b, 0);
        var max = sumCash + Math.abs(sum) - this.entity.bonusPaidAmount;
        return this.isFullPayment ? max : Number.MAX_SAFE_INTEGER;
      },
    },

    minCashPaidAmount: {
      get() {
        var sum = this.promotionsInEntity
          .filter((x) => x.value < 0)
          .map((x) => x.value)
          .reduce((a, b) => a + b, 0);
        var cashPaidAmount =
          this.products.map((x) => x.price).reduce((a, b) => a + b, 0) +
          Math.abs(sum) -
          this.entity.bonusPaidAmount -
          this.entity.paymentAmount;
        return cashPaidAmount;
      },
    },

    paymentTime: {
      get() {
        return this.time;
      },
      set(value) {
        this.time = value;
        let date = this.paymentDate + "T" + value + ":00";
        this.entity.paymentTime = new Date(date);
      },
    },
    paymentDate: {
      get() {
        return this.date;
      },
      set(value) {
        if (this.paymentTime) {
          let date = value + "T" + this.paymentTime;
          this.entity.paymentTime = new Date(date);
        } else {
          this.entity.paymentTime = new Date(value);
        }
        this.date = value;
      },
    },
    isRetail: {
      get() {
        return this.entity?.kind === "Retail";
      },
    },
    isTailoring: {
      get() {
        return (
          this.entity?.fulfillmentKind === "Tailoring" ||
          this.$route.query.fulfillmentKind === "Tailoring"
        );
      },
    },
    prePaymentBaseValue: {
      get() {
        return this.isTailoring
          ? this.defaultTailoringPrePayment
          : this.defaultPrePayment;
      },
    },
    prePaymentStepValue: {
      get() {
        return this.isTailoring
          ? this.defaultTailoringPrePaymentStep
          : this.defaultPrePaymentStep;
      },
    },
    orderTitle: {
      get() {
        const caption = this.isTailoring ? "Відшив" : "Замовлення";
        return this.entity?.number ? `${caption} №${this.entity.number}` : caption;
      },
    },
  },
  data() {
    return {
      isBlockSubmit: false,
      searchProduct: "",
      action: null,
      balance: 0,
      cashPaidAmount: 0,
      product: {
        productId: null,
        productRemainId: null,
        productRemain: null,
        quantity: 1,
      },
      promotion: { promotionId: null, id: null, typeId: null, value: 0 },
      time: "00:00",
      date: null,
      entity: { id: null },
      products: [],
      lookupLoading: false,
      productSearchTimeout: null,
      productLookupRequestId: 0,
      productLookupAbortController: null,
      lookupPagination: {
        page: 1,
        count: 0,
        packageSize: 10,
        totalPages: 0,
        entities: [],
      },
      selectedLookupProduct: null,
      lookupScrollElement: null,
      productHeaders: [{ name: this.$filters.localize("tableColumns.common.product") }, { name: this.$filters.localize("main.size") }, { name: this.$filters.localize("tableColumns.common.price") }],
      promotionHeaders: [{ name: this.$filters.localize("tableColumns.common.promotion_name") }],
      fops: [],
      promotionsInEntity: [],
      promotions: [],
      deliveryTypes: [],
      deliveryServices: [],
      defaultPrePayment: 150,
      defaultPrePaymentStep: 100,
      defaultTailoringPrePayment: 300,
      defaultTailoringPrePaymentStep: 100,
    };
  },
  watch: {
    "$route.fullPath": {
      handler() {
        this.initialize();
      },
      immediate: true,
    },
  },
  methods: {
    async initialize() {
      this.resetLookupState();
      this.products = [];
      this.promotionsInEntity = [];
      this.balance = 0;
      await this.onLoadData(this.$route.params.id);
      this.onLoadLookups();
    },
    getLookupDisplayLabel(option) {
      if (!option?.product) {
        return "";
      }

      const term = this.isTailoring && option.product.tailoringTermName
        ? `${option.product.tailoringTermName} днів / `
        : "";

      return `${option.product.code} (${term}${this.formatLookupPrice(
        this.getProductDisplayPrice(option.product)
      )} грн)`;
    },
    getLookupOptionLabel(option) {
      if (!option?.product) {
        return "";
      }

      return `${option.product.code} (${this.formatLookupPrice(option.product.wholeSalePrice)} грн)`;
    },
    getProductDisplayPrice(product) {
      return this.isRetail ? product?.price ?? 0 : product?.wholeSalePrice ?? 0;
    },
    formatLookupPrice(value) {
      const amount = Number(value ?? 0);
      return Number.isInteger(amount) ? amount.toString() : amount.toFixed(2);
    },
    getLookupCharacterLabel(option) {
      if (!option?.character) {
        return "";
      }

      return option.character.name;
    },
    addPromotion() {
      this.promotionsInEntity.push(this.promotion);
      this.promotion = { promotionId: null, id: null, value: 0 };
    },
    rmPromotion(id) {
      this.promotionsInEntity = this.promotionsInEntity.filter(
        (_, index) => index !== id
      );
    },
    getPromotionProductBonusPromotion() {
      const { PROMO_PRODUCT } = PromotionTypes;
      return this.promotions.find(
        (x) => x.typeId === PROMO_PRODUCT && Number(x.value) > 0
      );
    },
    getPromotionProductCount() {
      return this.products.filter((x) => x.product?.isPromotion).length;
    },
    buildPromotionInOrder(promotion) {
      return {
        promotionId: promotion.id,
        id: null,
        typeId: promotion.typeId,
        value: promotion.value,
      };
    },
    syncPromotionProductBonus() {
      const bonusPromotion = this.getPromotionProductBonusPromotion();
      if (!bonusPromotion) {
        return;
      }

      const requiredCount = this.isFullPayment
        ? this.getPromotionProductCount()
        : 0;
      const bonusIndexes = this.promotionsInEntity
        .map((promotion, index) => ({ promotion, index }))
        .filter(({ promotion }) => promotion.promotionId === bonusPromotion.id)
        .map(({ index }) => index);

      if (bonusIndexes.length < requiredCount) {
        const missingCount = requiredCount - bonusIndexes.length;
        for (let index = 0; index < missingCount; index += 1) {
          this.promotionsInEntity.push(this.buildPromotionInOrder(bonusPromotion));
        }
        return;
      }

      if (bonusIndexes.length > requiredCount) {
        const indexesToRemove = bonusIndexes.slice(requiredCount);
        this.promotionsInEntity = this.promotionsInEntity.filter(
          (_, index) => !indexesToRemove.includes(index)
        );
      }
    },
    addProduct() {
      const productRemain = this.selectedLookupProduct?.remains?.find(
        (x) => x.id == this.product.productRemainId
      );

      if (!productRemain || !this.selectedLookupProduct) {
        return;
      }

      this.products.push({
        ...this.product,
        productRemain,
        product: {
          ...this.selectedLookupProduct.product,
          tailoringTermName: this.selectedLookupProduct.product?.tailoringTermName,
        },
        price: this.getProductDisplayPrice(this.selectedLookupProduct.product),
      });
      this.cashPaidAmount = this.products
        .map((x) => x.price)
        .reduce((a, b) => a + b, 0);
      this.syncPromotionProductBonus();
      this.resetSelectedProduct(true);
    },
    rmProduct(id) {
      this.products = this.products.filter((_, index) => index !== id);
      this.cashPaidAmount = this.products
        .map((x) => x.price)
        .reduce((a, b) => a + b, 0);
      this.syncPromotionProductBonus();
    },
    getTailoringTermLabel(row) {
      const term = row?.product?.tailoringTermName || row?.product?.tailoringTerm?.name;
      return term ? `${term} днів` : "-";
    },
    confirm() {
      if (Number(this.entity.paymentAmount || 0) < this.minPaymentAmount) {
        this.$toast.warning(
          `Мінімальна передплата для цього замовлення становить ${this.minPaymentAmount} грн.`
        );
        return;
      }

      this.isBlockSubmit = true;
      var path =
        window.location.origin +
        "/api/v1/order/" +
        (this.action === "add" ? "create" : "confirm");
      this.$http
        .post(path, this.request)
        .then((response) => {
          this.entity = response.data.data;
          this.$route.params.id = this.entity.id;
          this.cashPaidAmount = response.data.data.totalCost;
          if (response.data.status) this.$toast.success("Замовлення успішно створено");
          else this.$toast.error(response.data.message);

          this.isBlockSubmit = false;
        })
        .catch((error) => {
          this.$toast.error(error.response.data.message);
          this.isBlockSubmit = false;
        });
    },
    onLoadLookups() {
      this.$store
        .dispatch("section", { table: "deliveryType" })
        .then((response) => {
          this.deliveryTypes = response.data.data;
        });
      this.$store
        .dispatch("section", { table: "deliveryService" })
        .then((response) => {
          this.deliveryServices = localizeDeliveryServices(response.data.data);
        });
      this.$store
        .dispatch("section", { table: "promotion" })
        .then((response) => {
          this.promotions = response.data.data.filter((x) => x.isActive);
          this.syncPromotionProductBonus();
        });
      this.$store
        .dispatch("section", { table: "paymentdetail" })
        .then((response) => {
          this.fops = response.data.data.filter((x) => x.isActive);
        });
      this.loadSettingByCode("DefaultPrePayment", 150).then((value) => {
        this.defaultPrePayment = value;
      });
      this.loadSettingByCode("DefaultPrePaymentStep", 100).then((value) => {
        this.defaultPrePaymentStep = value;
      });
      this.loadSettingByCode("DefaultTailoringPrePayment", 300).then((value) => {
        this.defaultTailoringPrePayment = value;
      });
      this.loadSettingByCode("DefaultTailoringPrePaymentStep", 100).then((value) => {
        this.defaultTailoringPrePaymentStep = value;
      });
    },
    loadSettingByCode(code, fallback) {
      return this.$store
        .dispatch("getFilter", {
          table: "SystemSetting",
          body: { id: code, rootColumn: "Code" },
        })
        .then((response) => Number(response.data.data?.[0]?.value ?? fallback))
        .then((value) => value || fallback);
    },
    onProductLookupOpen() {
      nextTick(() => {
        this.bindLookupScroll();
      });
      if (this.lookupPagination.entities.length === 0) {
        this.lookupPagination.page = 1;
        this.loadProductLookup({ append: false });
      }
    },
    onProductLookupClose() {
      this.unbindLookupScroll();
    },
    onProductSearch(value) {
      const search = value?.trim() ?? "";
      if (!search && this.selectedLookupProduct) {
        return;
      }

      this.searchProduct = search;
      this.lookupPagination.page = 1;
      this.resetSelectedProduct();
      window.clearTimeout(this.productSearchTimeout);
      this.productSearchTimeout = window.setTimeout(() => {
        this.loadProductLookup({ append: false });
      }, 300);
    },
    loadProductLookup({ append = false } = {}) {
      if (append && this.lookupLoading) {
        return Promise.resolve();
      }

      this.cancelProductLookupRequest();
      const controller = new AbortController();
      this.productLookupAbortController = controller;
      this.lookupLoading = true;
      const requestId = ++this.productLookupRequestId;
      const params = new URLSearchParams({
        page: this.lookupPagination.page,
        size: this.lookupPagination.packageSize,
      });

      if (this.searchProduct) {
        params.set("search", this.searchProduct);
      }

      return this.$store
        .dispatch("get", {
          table: "productremains",
          method: "search?" + params.toString(),
          signal: controller.signal,
        })
        .then((response) => {
          if (requestId !== this.productLookupRequestId) {
            return;
          }

          const data = response.data.data;
          this.lookupPagination = {
            ...data,
            entities: append
              ? this.mergeLookupEntities(
                this.lookupPagination.entities,
                data.entities ?? []
              )
              : data.entities ?? [],
          };
        })
        .catch((error) => {
          if (error.code !== "ERR_CANCELED") {
            throw error;
          }
        })
        .finally(() => {
          if (requestId === this.productLookupRequestId) {
            this.lookupLoading = false;
            this.productLookupAbortController = null;
          }
        });
    },
    cancelProductLookupRequest() {
      if (this.productLookupAbortController) {
        this.productLookupAbortController.abort();
        this.productLookupAbortController = null;
      }
    },
    mergeLookupEntities(currentItems, nextItems) {
      const map = new Map();
      [...currentItems, ...nextItems].forEach((item) => {
        map.set(item.productId, item);
      });
      return [...map.values()];
    },
    bindLookupScroll() {
      this.unbindLookupScroll();
      const dropdownMenu = this.$el.querySelector(".vs__dropdown-menu");
      if (!dropdownMenu) {
        return;
      }

      dropdownMenu.addEventListener("scroll", this.onLookupScroll);
      this.lookupScrollElement = dropdownMenu;
    },
    unbindLookupScroll() {
      if (!this.lookupScrollElement) {
        return;
      }

      this.lookupScrollElement.removeEventListener("scroll", this.onLookupScroll);
      this.lookupScrollElement = null;
    },
    onLookupScroll(event) {
      const element = event.target;
      const threshold = 24;
      const isNearBottom =
        element.scrollTop + element.clientHeight >=
        element.scrollHeight - threshold;

      if (!isNearBottom || this.lookupLoading || !this.hasMoreLookupPages) {
        return;
      }

      this.lookupPagination.page += 1;
      this.loadProductLookup({ append: true });
    },
    selectLookupProduct(item) {
      if (!item) {
        this.resetSelectedProduct();
        return;
      }

      this.selectedLookupProduct = item;
      this.product = {
        productId: item.productId,
        productRemainId: null,
        productRemain: null,
        quantity: 1,
        price: this.getProductDisplayPrice(item.product),
      };
    },
    resetSelectedProduct(clearSearch = false) {
      this.selectedLookupProduct = null;
      if (clearSearch) {
        this.searchProduct = "";
      }
      this.product = {
        productId: null,
        productRemainId: null,
        productRemain: null,
        quantity: 1,
        price: 0,
      };
    },
    resetLookupState() {
      this.lookupLoading = false;
      window.clearTimeout(this.productSearchTimeout);
      this.cancelProductLookupRequest();
      this.lookupPagination = {
        page: 1,
        count: 0,
        packageSize: 10,
        totalPages: 0,
        entities: [],
      };
      this.unbindLookupScroll();
      this.resetSelectedProduct(true);
    },
    onSubLoadData(id) {
      this.$store
        .dispatch("getFilter", {
          table: "OrderProduct",
          body: { id: id, rootColumn: "ActivityId" },
        })
        .then((response) => {
          this.products = response.data.data;
          this.syncPromotionProductBonus();
        });
      this.$store
        .dispatch("get", {
          table: "transaction",
          method: "balance?contactId=" + this.entity.contactId,
        })
        .then((response) => {
          this.balance = response.data.data;
        });
      this.$store
        .dispatch("getFilter", {
          table: "PromotionInOrder",
          body: { id: id, rootColumn: "OrderId" },
        })
        .then((response) => {
          this.promotionsInEntity = response.data.data;
          this.syncPromotionProductBonus();
        });
    },
    onLoadData(id) {
      const kind = "Wholesale";
      const fulfillmentKind = this.$route.query.fulfillmentKind || "Standard";
      return this.$store
        .dispatch("index", { table: "order", body: { id: id, kind, fulfillmentKind } })
        .then((response) => {
          var result = response.data;
          this.entity = result.data;
          this.entity.kind = "Wholesale";
          this.$route.params.id = this.entity.id;
          this.cashPaidAmount = result.data.totalCost;
          this.action = result.status ? "update" : "add";
          this.onSubLoadData(id);
        })
        .catch(() => {
          this.$toast.error(
            "Системна помилка. Не вдалось отримати інформацію."
          );
        });
    },
  },
  beforeUnmount() {
    window.clearTimeout(this.productSearchTimeout);
    this.cancelProductLookupRequest();
    this.unbindLookupScroll();
  },
};
</script>
<style scoped>
.flow-show {
  overflow-y: auto;
  max-height: none;
  padding-bottom: 2rem;
}

.bot-order-page {
  width: 100%;
  max-width: 1120px;
  min-height: 100%;
  padding: 0;
  overflow: visible;
}

.bot-order-form {
  width: 100%;
  min-height: auto;
  padding: 16px;
  border: 1px solid #e4eaf2;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 14px 30px rgba(15, 38, 65, 0.08);
}

.bot-order-page > .mb-3 {
  margin-bottom: 12px !important;
  padding: 10px 14px;
  border: 1px solid #e4eaf2;
  border-radius: 8px;
  color: #173b5d;
  background: #ffffff;
  box-shadow: 0 8px 20px rgba(15, 38, 65, 0.05);
  font-weight: 800;
}

.product-add-form {
  display: grid;
  grid-template-columns: minmax(0, 1.8fr) minmax(180px, 0.9fr) auto;
  gap: 0.75rem;
  align-items: end;
  padding: 0.9rem 1rem;
  border: 1px solid #e4eaf2;
  border-radius: 8px;
  background: #f7fafc;
}

.product-add-control {
  min-width: 0;
}

.product-add-button {
  min-width: 120px;
  height: 38px;
  border-color: #d9e2ec;
  border-radius: 8px;
  color: #173b5d;
  background: #ffffff;
  font-weight: 800;
  white-space: nowrap;
}

.product-add-form :deep(.vs__dropdown-toggle) {
  min-height: 38px;
  height: 38px;
  border-color: #d9e2ec;
  border-radius: 8px;
  background: #fff;
}

.product-add-form :deep(.vs__actions) {
  padding-right: 0.35rem;
}

.bot-order-page :deep(.bot-select-no-clear .vs__clear) {
  display: none;
}

.product-add-form :deep(.vs__selected-options) {
  flex-wrap: nowrap;
  overflow: hidden;
}

.product-add-form :deep(.vs__selected) {
  margin: 0;
}

.product-add-form :deep(.vs__search),
.product-add-form :deep(.vs__search:focus) {
  margin: 0;
}

.promotion-add-form {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 0.75rem;
  align-items: end;
  padding: 0.9rem 1rem;
  border: 1px solid #e4eaf2;
  border-radius: 8px;
  background: #f7fafc;
}

.promotion-add-control {
  min-height: 38px;
  height: 38px;
  background: #fff;
}

.promotion-add-actions {
  display: flex;
}

.promotion-add-button {
  min-width: 120px;
  height: 38px;
  border-color: #d9e2ec;
  border-radius: 8px;
  color: #173b5d;
  background: #ffffff;
  font-weight: 800;
  white-space: nowrap;
}

.bot-order-form .table {
  border: 1px solid #e4eaf2;
  border-radius: 8px;
  overflow: hidden;
  background: #ffffff;
}

.bot-order-form .table th {
  color: #526171;
  background: #f7fafc;
  font-size: 0.76rem;
  text-transform: uppercase;
  white-space: nowrap;
}

.bot-order-form .form-control {
  min-height: 38px;
  border-color: #d9e2ec;
  border-radius: 8px;
}

.bot-order-form :deep(.v-select) {
  width: 100%;
  min-height: 38px;
  text-align: left;
}

.bot-order-form :deep(.vs__dropdown-toggle) {
  min-height: 38px;
  height: 38px;
  border-color: #d9e2ec;
  border-radius: 8px;
  background: #ffffff;
}

.bot-order-form :deep(.vs__selected-options) {
  min-width: 0;
  align-items: center;
  flex-wrap: nowrap;
  overflow: hidden;
  padding: 0 8px;
}

.bot-order-form :deep(.vs__selected) {
  min-width: 0;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.bot-order-form :deep(.vs__search),
.bot-order-form :deep(.vs__search:focus) {
  margin: 0;
  padding: 0;
}

.bot-order-form :deep(.vs__actions) {
  align-items: center;
  height: 38px;
  padding: 0 8px 0 4px;
}

.bot-order-form :deep(.vs__open-indicator) {
  display: block;
}

.bot-order-form .btn {
  border-radius: 8px;
  font-weight: 800;
}

@media (max-width: 767.98px) {
  .bot-order-page {
    height: auto;
    max-width: none;
    padding-left: 12px;
    padding-right: 12px;
  }

  .bot-order-form {
    padding: 12px;
  }

  .product-add-form {
    grid-template-columns: 1fr;
    padding: 0.75rem 0.9rem;
  }

  .product-add-button {
    width: 100%;
  }

  .promotion-add-form {
    grid-template-columns: 1fr;
    padding: 0.75rem 0.9rem;
  }

  .promotion-add-button {
    width: 100%;
  }

  .bot-order-form .form-control,
  .bot-order-form :deep(.vs__selected),
  .bot-order-form :deep(.vs__search),
  .bot-order-form :deep(.vs__search:focus),
  .bot-order-form :deep(.vs__dropdown-option) {
    font-size: 16px;
  }
}
</style>
